export default "__VITE_ASSET__f0f1a359__"